/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesNeuronsNeuronIdPngRequest = {
  neuronId: number;
};

/** @internal */
export const GetApiV3ImagesNeuronsNeuronIdPngRequest$inboundSchema: z.ZodType<
  GetApiV3ImagesNeuronsNeuronIdPngRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  neuron_id: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "neuron_id": "neuronId",
  });
});

/** @internal */
export type GetApiV3ImagesNeuronsNeuronIdPngRequest$Outbound = {
  neuron_id: number;
};

/** @internal */
export const GetApiV3ImagesNeuronsNeuronIdPngRequest$outboundSchema: z.ZodType<
  GetApiV3ImagesNeuronsNeuronIdPngRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3ImagesNeuronsNeuronIdPngRequest
> = z.object({
  neuronId: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    neuronId: "neuron_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesNeuronsNeuronIdPngRequest$ {
  /** @deprecated use `GetApiV3ImagesNeuronsNeuronIdPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesNeuronsNeuronIdPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesNeuronsNeuronIdPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesNeuronsNeuronIdPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesNeuronsNeuronIdPngRequest$Outbound` instead. */
  export type Outbound = GetApiV3ImagesNeuronsNeuronIdPngRequest$Outbound;
}

export function getApiV3ImagesNeuronsNeuronIdPngRequestToJSON(
  getApiV3ImagesNeuronsNeuronIdPngRequest:
    GetApiV3ImagesNeuronsNeuronIdPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesNeuronsNeuronIdPngRequest$outboundSchema.parse(
      getApiV3ImagesNeuronsNeuronIdPngRequest,
    ),
  );
}

export function getApiV3ImagesNeuronsNeuronIdPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesNeuronsNeuronIdPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesNeuronsNeuronIdPngRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ImagesNeuronsNeuronIdPngRequest' from JSON`,
  );
}
